import { CheckCircleOutline, ErrorOutline, HourglassBottom } from '@mui/icons-material';
import { ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { ROLLOVER_FAILED_MESSAGE } from 'components/MeasurementDates/constants';
import {
  COMPLETE,
  FAILED,
  PENDING,
  POLLING,
  TIMEOUT,
  TIMEOUT_MESSAGE,
} from 'hooks/useRollingApiRequest/useRollingApiRequest.props';
import { STATUS } from 'services/hooks/useRolloverCompanies/rollover.types';
import { StatusListItemProps } from './StatusListItem.props';
import { classes, StyledListItem } from './StatusListItem.styles';

const StatusListItem = ({ item, index, idNameMap }: StatusListItemProps) => {
  // A failed row always says why, with a generic reason when the server sent none.
  const failureReason = item.state === FAILED ? item.errorMsg || ROLLOVER_FAILED_MESSAGE : undefined;

  return (
    <StyledListItem className={index % 2 !== 0 ? classes.selected : ''}>
      <ListItemText primary={idNameMap[item.key]} secondary={failureReason} />
      <ListItemIcon>
        {item.state === TIMEOUT && (
          <Tooltip title={TIMEOUT_MESSAGE}>
            <HourglassBottom />
          </Tooltip>
        )}
        {[PENDING, POLLING].includes(item.state) && <CircularProgress size={24} />}
        {item.state === COMPLETE && <CheckCircleOutline color="primary" />}
        {failureReason && (
          <Tooltip title={failureReason}>
            <ErrorOutline color="error" />
          </Tooltip>
        )}
        {item.state === STATUS.CONFLICT && <CheckCircleOutline />}
      </ListItemIcon>
    </StyledListItem>
  );
};

export default StatusListItem;
